module.exports = __webpack_public_path__ + "static/media/sumofus-white-logo-horizontal.f731373a.svg";